module.exports = __webpack_public_path__ + "static/media/inherited_ira.630274c9.png";